import { useTranslation } from "react-i18next";
import { useState } from "react";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import ChooseWebshopType from "./views/ChooseWebshopType";
import Credentials from "./views/Credentials";
import { useCreateWebshopCredentialsMutation } from "../../../../newapi/webshop/webshopSlice";
import MeasurementUnits from "./views/MeasurementUnits";
import Sync from "./views/Sync";
import EtailizeMarketplaceSelection from "./views/etailize/EtailizeMarketplaceSelection";
import EtailizeAuthentication from "./views/etailize/EtailizeAuthentication";
import EtailizeCredentials from "./views/etailize/EtailizeCredentials";
import EtailizePropagation from "./views/etailize/EtailizePropagation";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../../Sidebar";
import { useGetSettingsForRelationQuery } from "../../../../newapi/global/generalApiSlice";
import MConfirmation from "../../Modals/MConfirmation";
import { relationCanEditProductDimensions } from "../../../../utils/relationProductDimensions";

const MpAddWebshop = (props) => {
    const {t} = useTranslation();

    const [CreateWebshopCredentials,{isLoading}] = useCreateWebshopCredentialsMutation();
    const [showConfirmation, setShowConfirmation] = useState(false);

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);

    const isRelation = selectedEnvironmentType === ENV_TYPES[200];

    const onSave = () => {
        if (isRelation) {
            setShowConfirmation(true);
        }

        props.handleClose();
    }

    const handleConfirmSave = () => {
        setShowConfirmation(false);
    }
    const {data: relationSettings, isLoading: isLoadingSettings} = useGetSettingsForRelationQuery();

    const isRelationEditProductDimensionsDisabled = isRelation && !isLoadingSettings &&
    !relationCanEditProductDimensions(relationSettings);

    if(isRelationEditProductDimensionsDisabled) {
        return (
            <>
                <ProgressionModal
                    open={props.open}
                    onClose={props.handleClose}
                >
                    <ProgressionWrapper onSave={onSave} query={useCreateWebshopCredentialsMutation} isModal title={t("add_saleschannel")}>
                        <ChooseWebshopType isRelationEditProductDimensionsDisabled={isRelationEditProductDimensionsDisabled}/>
                        <EtailizeMarketplaceSelection/>
                        <EtailizeCredentials/>
                        <EtailizePropagation/>
                        <EtailizeAuthentication/>
                        <Credentials isRelationEditProductDimensionsDisabled={isRelationEditProductDimensionsDisabled}/>
                        <Sync isRelationEditProductDimensionsDisabled={isRelationEditProductDimensionsDisabled}/>
                    </ProgressionWrapper>
                </ProgressionModal>
                <MConfirmation
                    open={showConfirmation}
                    handleClose={() => setShowConfirmation(false)}
                    confirm={handleConfirmSave}
                    title={t("close_modal")}
                    subtitle={t("are_you_sure_close_modal")}
                />
            </>
        )
    }

    return (
        <>
            <ProgressionModal
                open={props.open}
                onClose={props.handleClose}
            >
                <ProgressionWrapper onSave={onSave} query={useCreateWebshopCredentialsMutation} isModal title={t("add_saleschannel")}>
                    <ChooseWebshopType/>
                    <EtailizeMarketplaceSelection/>
                    <EtailizeAuthentication/>
                    <EtailizeCredentials/>
                    <EtailizePropagation/>
                    <Credentials/>
                    <MeasurementUnits/>
                    <Sync/>
                </ProgressionWrapper>
            </ProgressionModal>
            <MConfirmation
                open={showConfirmation}
                handleClose={() => setShowConfirmation(false)}
                confirm={handleConfirmSave}
                title={t("sales_channel_activation_pending")}
                content={t("sales_channel_activation_pending_text")}
            />
        </>
    )
}

export default MpAddWebshop;